import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, withCtx as _withCtx, resolveComponent as _resolveComponent, withModifiers as _withModifiers, createElementVNode as _createElementVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps } from "vue";
const _hoisted_1 = {
  class: "flex w-full"
};
const _hoisted_2 = {
  class: "mr-1"
};
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", {
  class: "grow"
}, null, -1);
const _hoisted_4 = {
  class: "ml-1"
};
import Talent from "@/modules/youth/components/Talent.vue";
import Flag from "@/modules/vue/components/Flag.vue";
import { app } from "@/di";
import { YouthPlayerNegotiationStarter } from "@/modules/youth/services/YouthPlayerNegotiationStarter";
import { Team } from "@/modules/team/entity";
import ActionScreen from "@/modules/action-screens/components/ActionScreen.vue";
import FormGroup from "@/modules/vue/components/FormGroup.vue";
import Icon from "@/modules/vue/components/Icon.vue";
export default /*#__PURE__*/_defineComponent({
  __name: 'ScoutedCompletedActionScreen',
  props: {
    player: null
  },
  emits: ['finished'],
  async setup(__props, {
    emit
  }) {
    let __temp, __restore;
    const props = __props;
    const canNegotiate = ref(false);
    const team = ([__temp, __restore] = _withAsyncContext(() => Team.current()), __temp = await __temp, __restore(), __temp);
    const youthPlayerNegotiationStarter = app.get(YouthPlayerNegotiationStarter);
    canNegotiate.value = ([__temp, __restore] = _withAsyncContext(() => youthPlayerNegotiationStarter.canNegotiation(team, props.player)), __temp = await __temp, __restore(), __temp);
    const message = useMessage();
    const negotiate = async () => {
      await youthPlayerNegotiationStarter.start(team, props.player);
      message.success(translator.t('negotiation_started'));
      emit('finished');
    };
    return (_ctx, _cache) => {
      const _component_NButton = _resolveComponent("NButton");
      return _openBlock(), _createBlock(ActionScreen, _normalizeProps(_guardReactiveProps(_ctx.$attrs)), {
        title: _withCtx(() => [_createVNode(Flag, {
          country: __props.player.country,
          class: "mr-1"
        }, null, 8, ["country"]), _createTextVNode(" " + _toDisplayString(__props.player.name), 1)]),
        subTitle: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('scouting_completed')), 1)]),
        controls: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [canNegotiate.value ? (_openBlock(), _createBlock(_component_NButton, {
          key: 0,
          secondary: "",
          type: "primary",
          block: "",
          onClick: _withModifiers(negotiate, ["stop"])
        }, {
          default: _withCtx(() => [_createVNode(Icon, {
            icon: _ctx.IconEnum.Handshake20Regular
          }, null, 8, ["icon"])]),
          _: 1
        }, 8, ["onClick"])) : _createCommentVNode("", true)]), _hoisted_3, _createElementVNode("div", _hoisted_4, [_createVNode(_component_NButton, {
          secondary: "",
          onClick: _cache[0] || (_cache[0] = $event => _ctx.$emit('finished'))
        }, {
          default: _withCtx(() => [_createVNode(Icon, {
            icon: _ctx.IconEnum.CheckRound
          }, null, 8, ["icon"])]),
          _: 1
        })])])]),
        default: _withCtx(() => [_createVNode(FormGroup, {
          label: _ctx.$t('age'),
          "value-width-ratio": 1 / 2
        }, {
          default: _withCtx(() => [!__props.player.canSee('age') ? (_openBlock(), _createBlock(Icon, {
            key: 0,
            icon: _ctx.IconEnum.QuestionCircle32Regular
          }, null, 8, ["icon"])) : (_openBlock(), _createElementBlock(_Fragment, {
            key: 1
          }, [_createTextVNode(_toDisplayString(__props.player.age), 1)], 64))]),
          _: 1
        }, 8, ["label"]), _createVNode(FormGroup, {
          label: _ctx.$t('position'),
          "value-width-ratio": 1 / 2
        }, {
          default: _withCtx(() => [!__props.player.canSee('position') ? (_openBlock(), _createBlock(Icon, {
            key: 0,
            icon: _ctx.IconEnum.QuestionCircle32Regular
          }, null, 8, ["icon"])) : (_openBlock(), _createElementBlock(_Fragment, {
            key: 1
          }, [_createTextVNode(_toDisplayString(__props.player.position), 1)], 64))]),
          _: 1
        }, 8, ["label"]), _createVNode(FormGroup, {
          label: _ctx.$t('skill'),
          "value-width-ratio": 1 / 2
        }, {
          default: _withCtx(() => [!__props.player.canSee('skill') ? (_openBlock(), _createBlock(Icon, {
            key: 0,
            icon: _ctx.IconEnum.QuestionCircle32Regular
          }, null, 8, ["icon"])) : (_openBlock(), _createBlock(Talent, {
            key: 1,
            talent: __props.player.skill
          }, null, 8, ["talent"]))]),
          _: 1
        }, 8, ["label"]), _createVNode(FormGroup, {
          label: _ctx.$t('talent'),
          "value-width-ratio": 1 / 2
        }, {
          default: _withCtx(() => [!__props.player.canSee('talent') ? (_openBlock(), _createBlock(Icon, {
            key: 0,
            icon: _ctx.IconEnum.QuestionCircle32Regular
          }, null, 8, ["icon"])) : (_openBlock(), _createBlock(Talent, {
            key: 1,
            talent: __props.player.talent
          }, null, 8, ["talent"]))]),
          _: 1
        }, 8, ["label"])]),
        _: 1
      }, 16);
    };
  }
});